var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    {
      attrs: { column: "", role: "region", "aria-label": "Gift page content" },
    },
    [
      _c("v-parallax", {
        attrs: {
          src: "https://gm.goz.fun/wp-content/uploads/2023/03/gifts-cover.png",
          height: "350",
          "aria-label": "Gift section background image",
          role: "img",
        },
      }),
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-layout",
            {
              attrs: {
                column: "",
                "pb-2": "",
                role: "region",
                "aria-label": "Gift dashboard",
              },
            },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg8: "",
                    "justify-center": "",
                  },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "profile-section-card--flex-toolbar",
                      attrs: { flat: "" },
                    },
                    [
                      _c("v-progress-linear", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isLoading,
                            expression: "isLoading",
                          },
                        ],
                        attrs: {
                          color: "accent",
                          indeterminate: "",
                          role: "progressbar",
                          "aria-label": "Loading gifts",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { attrs: { flat: "" } },
                        [
                          _c(
                            "v-container",
                            { attrs: { fluid: "", "grid-list-md": "" } },
                            [
                              _c(
                                "v-tabs",
                                {
                                  attrs: {
                                    "fixed-tabs": "",
                                    color: "accent",
                                    "show-arrows": "",
                                    centered: "",
                                    "next-icon": "fad fa-chevron-right",
                                    "prev-icon": "fad fa-chevron-left",
                                    "slider-color": "accent",
                                    role: "tablist",
                                    "aria-label": "Gift tab navigation",
                                  },
                                },
                                [
                                  _c("v-tabs-slider"),
                                  _vm._v(" "),
                                  _vm._l(_vm.tabs, function (tab) {
                                    return _c(
                                      "v-tab",
                                      {
                                        key: tab.id,
                                        attrs: {
                                          to: tab.route,
                                          exact: "",
                                          role: "tab",
                                          "aria-label":
                                            tab.label ||
                                            _vm.$t("gift.tabs." + tab.id) ||
                                            tab.id,
                                          "aria-selected":
                                            _vm.$route.path === tab.route,
                                          tabindex:
                                            _vm.$route.path === tab.route
                                              ? 0
                                              : -1,
                                        },
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { "aria-hidden": true } },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(tab.icon) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v(
                                            _vm._s(
                                              tab.label ||
                                                _vm.$t("gift.tabs." + tab.id) ||
                                                tab.id
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  }),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("router-view", {
                                attrs: {
                                  "zushin-points": _vm.zushinPoints,
                                  role: "region",
                                  "aria-live": "polite",
                                  "aria-label": "Gift content section",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }